import React from 'react';
import { workloadPriceClassName } from './Styles';

interface CpuItemProps {
  badge: string;
  badgeType?: 'general' | 'memory';
  title: string;
  price: string;
  priceUnit?: string;
}

export default function CpuItem({
  badge,
  badgeType = 'general',
  title,
  price,
  priceUnit = ' / hour'
}: CpuItemProps) {
  const badgeClassName =
    badgeType === 'memory'
      ? 'bg-indigo-50 border border-indigo-200 text-indigo-600'
      : 'bg-gray-blue-50 border border-gray-blue-200 text-gray-blue-600';

  return (
    <div className="flex flex-col items-center px-3xl pt-3xl pb-7xl gap-s w-[300px]">
      <span
        className={`${badgeClassName} px-xs py-3xs rounded-full text-sm font-medium leading-2xs`}
      >
        {badge}
      </span>
      <span className="font-semibold text-gray-900 text-5xl leading-18xl">
        {title}
      </span>
      <span className={workloadPriceClassName}>
        {price}
        <span className="font-medium text-xl leading-3xl">{priceUnit}</span>
      </span>
    </div>
  );
}
